import { lm } from "../../../tools/language/LanguageManager";

export class PruefungManagerForStudentsMessages {
    static pruefungLaeuft = () => lm({
        'de': 'Prüfung läuft!',
        'en': 'Test is running!'
    });
    
}